import { Loader2 } from 'lucide-react';
import type { ComponentProps } from 'react';
import { cn } from '../lib/utils.js';

/**
 * Indeterminate in-flight mark. Same primitive as shadcn's Spinner: Lucide
 * `Loader2` plus `animate-spin`, with `role="status"` so a screen reader gets
 * a name instead of a decorative icon.
 */
function Spinner({ className, ...props }: ComponentProps<'svg'>) {
  return (
    <Loader2
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
